module.exports = __webpack_public_path__ + "static/media/logo2.7380f664.gif";